import BusinessObjectIndex from "./businessObjectIndex"

export const getBusinessobjectPoolsRedux = (
  actionType: string,
  failureCallback: (err:any) => void | null,
) => {
    window.parent.primingcloudRedux.businessobject.getBusinessobjectPools(
      actionType,
      failureCallback
    )
}

export const loadEntryRedux = (
  poolId: number,
  thingId: number,
  mdKey: string,
  actionType: string,
  failureCallback: (err:any) => void | null,
) => {
    window.parent.primingcloudRedux.businessobject.loadEntry(
      poolId,
      thingId,
      mdKey,
      actionType,
      failureCallback
    )
}

export const loadEntriesRedux = (
  poolId: number,
  thingId: number,
  mdKeyStart: string,
  limit: number,
  actionType: string,
  failureCallback: (err:any) => void | null
) => {
  window.parent.primingcloudRedux.businessobject.loadEntries(
    poolId,
    thingId,
    mdKeyStart,
    limit,
    actionType,
    failureCallback
  )
}

export const listRedux = (
  poolId: number,
  thingId: number,
  mdKeyStart: string,
  limit: number,
  actionType: string,
  failureCallback: (err:any) => void | null
  ) => {
    window.parent.primingcloudRedux.businessobject.list(
      poolId,
      thingId,
      mdKeyStart,
      limit,
      actionType,
      failureCallback
      )
}

export const queryRedux = (
  query: BusinessObjectIndex,
  poolId: number,
  thingId: number,
  mdKeyStart: string | null,
  limit: number,
  actionType: string,
  failureCallback: (err:any) => void | null
) => {
  
    window.parent.primingcloudRedux.businessobject.query(
      query,
      poolId,
      thingId,
      mdKeyStart,
      limit,
      actionType,
      failureCallback
    );
}

export const createEntryRedux = (
  poolId: number,
  thingId: number,
  mdKeyStart: string,
  value: any,
  actionType: string,
  failureCallback: (err:any) => void | null,
) => {
  window.parent.primingcloudRedux.businessobject.createEntry(
    poolId,
    thingId,
    mdKeyStart,
    value,
    actionType,
    failureCallback
    )
}

export const deleteEntryRedux = (
  poolId: number,
  thingId: number,
  mdKeyStart: string,
  actionType: string,
  failureCallback: (err:any) => void | null
) => {
    window.parent.primingcloudRedux.businessobject.deleteEntry(
      poolId,
      thingId,
      mdKeyStart,
      actionType,
      failureCallback,
    )
}

export const generateMapRedux = () => {
  window.parent.primingcloudRedux.businessobject.generateMap();
}
